import { frontendURL } from 'dashboard/helper/URLHelper.js';
import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import HomeCampaignPage from './pages/whatsapp_oficial/HomeCampaignPage.vue';
import CreateCampaignPage from './pages/whatsapp_oficial/components/CreateCampaignPage.vue';
import SettingsContent from './pages/CampaingWrapper.vue';
import CampaignChannel from './pages/CampaignChannel.vue';
import CampaignConfigureList from './pages/whatsapp_oficial/components/ConfigureList/CampaignConfigureList.vue';
import CampaignSchedule from './pages/whatsapp_oficial/components/CampaignSchedule.vue';
import CampaignFinish from './pages/whatsapp_oficial/components/CampaignFinish.vue';
import ScheduleCampaignList from './pages/whatsapp_oficial/reports/ScheduleCampaignList.vue';
import ScheduleCampaignDeliveries from './pages/whatsapp_oficial/reports/deliveries/ScheduleCampaignDeliveries.vue';

// Componentes do WhatsApp App
import HomeCampaignAppPage from './pages/whatsapp_app/HomeCampaignAppPage.vue';
import CreateCampaignAppPage from './pages/whatsapp_app/components/CreateCampaignPage.vue';
import ScheduleCampaignAppPage from './pages/whatsapp_app/ScheduleCampaignPage.vue';
import CampaignConfigureListApp from './pages/whatsapp_app/components/ConfigureList/CampaignConfigureList.vue';
import CampaignScheduleApp from './pages/whatsapp_app/components/CampaignSchedule.vue';
import CampaignFinishApp from './pages/whatsapp_app/components/CampaignFinish.vue';
import ScheduleCampaignListApp from './pages/whatsapp_app/reports/ScheduleCampaignList.vue';
import ScheduleCampaignDeliveriesApp from './pages/whatsapp_oficial/reports/deliveries/ScheduleCampaignDeliveries.vue';

// Gating só por permissão de admin (mesmo padrão do Studio). Sem
// featureFlag pra não esconder os sub-itens do sidebar em contas onde a
// flag WHATSAPP_CAMPAIGNS não está habilitada.
const meta = {
  permissions: ['administrator'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: 'new',
          component: SettingsContent,
          props: route => {
            const templateName = route.query.templateName;
            const currentRoute = route.name;
            let backUrl = {};

            // ✅ Configuração corrigida dos backUrls para WhatsApp Oficial
            if (currentRoute === 'campaigns_whatsapp_official_home_create') {
              backUrl = {
                name: 'campaigns_whatsapp_official_home',
                params: { accountId: route.params.accountId },
              };
            } else if (
              currentRoute === 'campaigns_whatsapp_official_configure_list'
            ) {
              backUrl = {
                name: 'campaigns_whatsapp_official_home_create',
                params: { accountId: route.params.accountId },
                query: { templateName },
              };
            } else if (
              currentRoute ===
              'campaigns_whatsapp_official_configure_google_sheets'
            ) {
              backUrl = {
                name: 'campaigns_whatsapp_official_home_create',
                params: { accountId: route.params.accountId },
                query: { templateName },
              };
            } else if (
              currentRoute === 'campaigns_whatsapp_official_schedule_step'
            ) {
              // ✅ Verificar se veio do Google Sheets para retornar à página correta
              const sourceType = route.query.sourceType;
              backUrl = {
                name:
                  sourceType === 'google_sheets'
                    ? 'campaigns_whatsapp_official_configure_google_sheets'
                    : 'campaigns_whatsapp_official_configure_list',
                params: { accountId: route.params.accountId },
                query: { templateName },
              };
            } else if (currentRoute === 'campaigns_whatsapp_official_finish') {
              // ✅ Preservar sourceType para navegação correta de volta
              const sourceTypeForFinish = route.query.sourceType;
              backUrl = {
                name: 'campaigns_whatsapp_official_schedule_step',
                params: { accountId: route.params.accountId },
                query: {
                  templateName,
                  ...(sourceTypeForFinish && {
                    sourceType: sourceTypeForFinish,
                  }),
                },
              };
            }
            // ✅ Configuração dos backUrls para WhatsApp App
            else if (currentRoute === 'campaigns_whatsapp_app_home_create') {
              backUrl = {
                name: 'campaigns_whatsapp_app_home',
                params: { accountId: route.params.accountId },
              };
            } else if (
              currentRoute === 'campaigns_whatsapp_app_configure_list'
            ) {
              backUrl = {
                name: 'campaigns_whatsapp_app_home_create',
                params: { accountId: route.params.accountId },
              };
            } else if (
              currentRoute === 'campaigns_whatsapp_app_schedule_step'
            ) {
              backUrl = {
                name: 'campaigns_whatsapp_app_configure_list',
                params: { accountId: route.params.accountId },
                query: { templateName },
              };
            } else if (currentRoute === 'campaigns_whatsapp_app_finish') {
              backUrl = {
                name: 'campaigns_whatsapp_app_schedule_step',
                params: { accountId: route.params.accountId },
                query: { templateName },
              };
            } else {
              // Fallback padrão → Home WhatsApp Oficial
              backUrl = {
                name: 'campaigns_whatsapp_official_home',
                params: { accountId: route.params.accountId },
              };
            }

            return {
              headerTitle: templateName,
              headerButtonText: 'Anterior',
              newButtonRoutes: [],
              showBackButton: true,
              showSidemenuIcon: true,
              keepAlive: true,
              backUrl,
            };
          },
          children: [
            {
              path: '',
              component: CampaignChannel,
              props: route => ({
                templateName: route.query.templateName,
                channelType: 'whatsapp_official',
                // 🟢 ADICIONANDO AS ROTAS PARA WHATSAPP OFICIAL
                campaignRoutes: {
                  CAMPAIGN_TYPE: 'campaigns_whatsapp_official_home_create',
                  CONFIGURE_LIST: 'campaigns_whatsapp_official_configure_list',
                  SCHEDULE: 'campaigns_whatsapp_official_schedule_step',
                  FINISH: 'campaigns_whatsapp_official_finish',
                },
              }),
              children: [
                // 🟢 ROTAS WHATSAPP OFICIAL (existentes) - CORRIGIDO: Usando 'meta' em vez de objeto inline
                {
                  path: '',
                  name: 'campaigns_whatsapp_official_home_create',
                  component: CreateCampaignPage,
                  meta, // ← CORRIGIDO: Agora usa a variável 'meta' com feature flag
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
                {
                  path: 'configure-list-tags',
                  name: 'campaigns_whatsapp_official_configure_list',
                  component: CampaignConfigureList,
                  meta, // ← CORRIGIDO: Agora usa a variável 'meta' com feature flag
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
                {
                  path: 'configure-google-sheets',
                  name: 'campaigns_whatsapp_official_configure_google_sheets',
                  component: () =>
                    import('./pages/whatsapp_oficial/components/ConfigureGoogleSheets/GoogleSheetsConfigureList.vue'),
                  meta,
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
                {
                  path: 'schedule',
                  name: 'campaigns_whatsapp_official_schedule_step',
                  component: CampaignSchedule,
                  meta, // ← CORRIGIDO: Agora usa a variável 'meta' com feature flag
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
                {
                  path: 'finish',
                  name: 'campaigns_whatsapp_official_finish',
                  component: CampaignFinish,
                  meta, // ← CORRIGIDO: Agora usa a variável 'meta' com feature flag
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
              ],
            },
          ],
        },

        // 🟢 NOVA SEÇÃO PARA CRIAR CAMPANHAS WHATSAPP APP
        {
          path: 'new-app',
          component: SettingsContent,
          props: route => {
            const templateName = route.query.templateName;
            const currentRoute = route.name;
            let backUrl = {};

            // Configuração dos backUrls para WhatsApp App
            if (currentRoute === 'campaigns_whatsapp_app_home_create') {
              backUrl = {
                name: 'campaigns_whatsapp_app_home',
                params: { accountId: route.params.accountId },
              };
            } else if (
              currentRoute === 'campaigns_whatsapp_app_configure_list'
            ) {
              backUrl = {
                name: 'campaigns_whatsapp_app_home_create',
                params: { accountId: route.params.accountId },
                query: { templateName },
              };
            } else if (
              currentRoute === 'campaigns_whatsapp_app_configure_google_sheets'
            ) {
              backUrl = {
                name: 'campaigns_whatsapp_app_home_create',
                params: { accountId: route.params.accountId },
                query: { templateName },
              };
            } else if (
              currentRoute === 'campaigns_whatsapp_app_configure_database'
            ) {
              backUrl = {
                name: 'campaigns_whatsapp_app_home_create',
                params: { accountId: route.params.accountId },
                query: { templateName },
              };
            } else if (
              currentRoute === 'campaigns_whatsapp_app_schedule_step'
            ) {
              const sourceType = route.query.sourceType;
              let backRouteName;
              if (sourceType === 'google_sheets') {
                backRouteName =
                  'campaigns_whatsapp_app_configure_google_sheets';
              } else if (sourceType === 'database') {
                backRouteName = 'campaigns_whatsapp_app_configure_database';
              } else {
                backRouteName = 'campaigns_whatsapp_app_configure_list';
              }
              backUrl = {
                name: backRouteName,
                params: { accountId: route.params.accountId },
                query: { templateName },
              };
            } else if (currentRoute === 'campaigns_whatsapp_app_finish') {
              const sourceTypeForFinish = route.query.sourceType;
              backUrl = {
                name: 'campaigns_whatsapp_app_schedule_step',
                params: { accountId: route.params.accountId },
                query: {
                  templateName,
                  ...(sourceTypeForFinish && {
                    sourceType: sourceTypeForFinish,
                  }),
                },
              };
            } else {
              backUrl = {
                name: 'campaigns_whatsapp_app_home',
                params: { accountId: route.params.accountId },
              };
            }

            return {
              headerButtonText: 'Anterior',
              newButtonRoutes: [],
              showBackButton: true,
              showSidemenuIcon: true,
              keepAlive: true,
              backUrl,
            };
          },
          children: [
            {
              path: '',
              component: CampaignChannel,
              props: route => ({
                templateName: route.query.templateName,
                channelType: 'whatsapp_app',
                // 🟢 ADICIONANDO AS ROTAS PARA WHATSAPP APP
                campaignRoutes: {
                  CAMPAIGN_TYPE: 'campaigns_whatsapp_app_home_create',
                  CONFIGURE_LIST: 'campaigns_whatsapp_app_configure_list',
                  SCHEDULE: 'campaigns_whatsapp_app_schedule_step',
                  FINISH: 'campaigns_whatsapp_app_finish',
                },
              }),
              children: [
                // 🟢 ROTAS WHATSAPP APP - CORRIGIDO: Usando 'meta' em vez de objeto inline
                {
                  path: '',
                  name: 'campaigns_whatsapp_app_home_create',
                  component: CreateCampaignAppPage,
                  meta,
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
                {
                  path: 'configure-list_tags',
                  name: 'campaigns_whatsapp_app_configure_list',
                  component: CampaignConfigureListApp,
                  meta,
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
                {
                  path: 'configure-google-sheets',
                  name: 'campaigns_whatsapp_app_configure_google_sheets',
                  component: () =>
                    import('./pages/whatsapp_app/components/ConfigureGoogleSheets/GoogleSheetsConfigureList.vue'),
                  meta,
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
                {
                  path: 'configure-database',
                  name: 'campaigns_whatsapp_app_configure_database',
                  component: CampaignConfigureList,
                  meta,
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
                {
                  path: 'schedule',
                  name: 'campaigns_whatsapp_app_schedule_step',
                  component: CampaignScheduleApp,
                  meta, // ← CORRIGIDO: Agora usa a variável 'meta' com feature flag
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
                {
                  path: 'finish',
                  name: 'campaigns_whatsapp_app_finish',
                  component: CampaignFinishApp,
                  meta, // ← CORRIGIDO: Agora usa a variável 'meta' com feature flag
                  props: route => ({
                    templateName: route.query.templateName,
                  }),
                },
              ],
            },
          ],
        },

        // 🟢 ROTAS WHATSAPP OFICIAL (existentes)
        {
          path: 'whatsapp-oficial',
          name: 'campaigns_whatsapp_official',
          meta,
          redirect: to => {
            return {
              name: 'campaigns_whatsapp_official_home',
              params: to.params,
            };
          },
          children: [
            {
              // Home recriada no padrão do Studio (header próprio + tabela
              // agrupada inbox → status). A anterior vive em `home-legacy`
              // como fallback divulgado até esta se provar.
              path: 'home',
              name: 'campaigns_whatsapp_official_home',
              meta,
              component: () =>
                import('./pages/whatsapp_oficial/home/CampaignTemplatesHome.vue'),
            },
            {
              path: 'home-legacy',
              name: 'campaigns_whatsapp_official_home_legacy',
              meta,
              component: HomeCampaignPage,
            },
            {
              path: 'create-template',
              name: 'campaigns_whatsapp_official_create_template',
              meta,
              component: () =>
                import('./pages/whatsapp_oficial/CreateTemplatePage.vue'),
            },
            {
              // Criação de campanha em passos — o grafo sai do stepper, a
              // validação e o compile no backend (POST campaigns/create_from_builder).
              path: 'builder',
              name: 'campaigns_whatsapp_official_builder',
              meta,
              component: () =>
                import('./pages/whatsapp_oficial/builder/CampaignBuilder.vue'),
            },
            {
              // Agendamentos recriados no padrão do Studio (tabela agrupada
              // por dia + drawer). A versão anterior foi aposentada.
              path: 'scheduling_index',
              name: 'campaigns_whatsapp_official_schedule',
              meta,
              component: () =>
                import('./pages/whatsapp_oficial/schedules/CampaignSchedulesPage.vue'),
            },
            {
              // Entregas recriadas no padrão do Studio (header + KPIs +
              // tabela). A página anterior segue viva na rota antiga
              // `scheduling_deliveries/` como fallback divulgado — nada no
              // fluxo novo aponta mais pra ela.
              path: 'schedules/:scheduling_id/deliveries',
              name: 'campaigns_whatsapp_official_deliveries',
              meta,
              component: () =>
                import('./pages/whatsapp_oficial/schedules/deliveries/ScheduleDeliveriesPage.vue'),
              props: route => ({
                schedulingId: route.params.scheduling_id,
                campaignId: route.query.campaignId,
                campaignTitle: route.query.title,
              }),
            },
            {
              path: 'scheduling_deliveries/:scheduling_id',
              name: 'campaigns_whatsapp_official_schedule_deliveries',
              meta,
              component: ScheduleCampaignDeliveries,
              props: route => ({
                schedulingId: route.params.scheduling_id,
              }),
            },
            {
              path: 'scheduling_list/:id',
              name: 'campaigns_whatsapp_official_schedule_list',
              meta,
              component: ScheduleCampaignList,
              props: route => ({
                campaignId: route.params.id,
              }),
            },
          ],
        },

        // 🟢 NOVAS ROTAS WHATSAPP APP
        {
          path: 'whatsapp-app',
          name: 'campaigns_whatsapp_app',
          meta,
          redirect: to => ({
            name: 'campaigns_whatsapp_app_home',
            params: to.params,
          }),
          children: [
            {
              path: 'home',
              name: 'campaigns_whatsapp_app_home',
              meta,
              component: HomeCampaignAppPage,
            },
            {
              path: 'templates',
              name: 'campaigns_whatsapp_app_templates',
              meta,
              component: () =>
                import('./pages/whatsapp_app/templates/TemplateBuilderPage.vue'),
            },
            {
              path: 'templates/:templateId',
              name: 'campaigns_whatsapp_app_template_edit',
              meta,
              component: () =>
                import('./pages/whatsapp_app/templates/TemplateBuilderPage.vue'),
              props: route => ({
                templateId: route.params.templateId,
              }),
            },
            {
              path: 'scheduling_index',
              name: 'campaigns_whatsapp_app_schedule',
              meta,
              component: ScheduleCampaignAppPage,
            },
            {
              path: 'scheduling_deliveries/:scheduling_id',
              name: 'campaigns_whatsapp_app_schedule_deliveries',
              meta,
              component: ScheduleCampaignDeliveriesApp,
              props: route => ({
                schedulingId: route.params.scheduling_id,
                backRouteName: 'campaigns_whatsapp_app_schedule',
                hideCostCard: true,
                hideBillable: true,
              }),
            },
            {
              path: 'scheduling_list/:id',
              name: 'campaigns_whatsapp_app_schedule_list',
              meta,
              component: ScheduleCampaignListApp,
              props: route => ({
                campaignId: route.params.id,
              }),
            },
          ],
        },
      ],
    },
  ],
};

export default campaignsRoutes;
